$(function() {
  var siblings = [];
  var groups = [];
  $(".wysiwyg_content")
    .children()
    .each(function() {
      if ($(this).is("p") && $(this).find("img").length > 1) {
        siblings = $(this).find("img");
        groups.push(siblings);
        siblings = [];
      } else if ($(this).is("figure")) {
        siblings.push(this);
      } else {
        if (siblings.length) {
          groups.push(siblings);
          siblings = [];
        }
      }

      if ($(this).is("table.capacity_table")) {
        $(this)
          .parent()
          .css("overflow-x", "scroll");
      }
    });

  if (siblings.length) {
    groups.push(siblings);
  }

  $.each(groups, function(i) {
    $(this[0]).addClass("group_first");
    $(this).addClass("group_" + this.length);
    $(this[this.length - 1]).addClass("group_last");
    if (
      $(this)
        .parent()
        .is("p")
    ) {
      $(this)
        .parent()
        .addClass("image_group");
    }
  });

  var iframes = $(".wysiwyg_content iframe");
  iframes.each(function() {
    $(this)
      .parent()
      .addClass("contains_iframe");
  });
});
